import { CalendarBlock } from "@moim/blockit";

interface IProps {
  date: Date;
  isSelected: boolean;
  hasEvent: boolean;
  userLocale: string;
}

const DateItem = ({ date, isSelected, hasEvent, userLocale }: IProps) => {
  return (
    <CalendarBlock.DateItem
      date={date}
      isSelected={isSelected}
      hasEvent={hasEvent}
      userLocale={userLocale}
    />
  );
};

export default DateItem;
